import UpdateProfilePicture from "./UpdateProfilePicture"

export default UpdateProfilePicture;